import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonos } from '../data/content';
export function BonusStack() {
  return <section className="w-full bg-zinc-900 py-16 lg:py-24" aria-labelledby="bonos-titulo" data-id="element-11" data-mp="3tphkzmwtmccv">
      <div className="mx-auto max-w-5xl px-6" data-id="element-12" data-mp="2lj6yicfec5g">
        <h2 id="bonos-titulo" className="max-w-2xl font-display text-3xl uppercase leading-tight text-white sm:text-4xl" data-id="element-13" data-mp="2in90u0kvnh0">
          Si te llevás el pack hoy, incluimos estas{' '}
          <span className="text-amber-400" data-id="element-14" data-mp="3b0azxt8k18nw">5 herramientas de regalo</span>
        </h2>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-15" data-mp="3axx59lhsdygv">
          {bonos.map((bono, index) => <li key={bono.titulo} className={`flex gap-4 rounded-lg bg-zinc-950 p-6 ring-1 ring-zinc-800 ${index === bonos.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-16" data-mp="3f01vea910cyr" data-mpi={index}>
              <GiftIcon className="mt-0.5 h-6 w-6 shrink-0 text-amber-400" aria-hidden="true" data-id="element-17" data-mp="2rbionz5mk88s" />
              <div data-id="element-18" data-mp="3sbbg39ofs4h2">
                <h3 className="text-base font-semibold text-white" data-id="element-19" data-mp="3s9s2xry2u9ji">
                  <span className="text-zinc-500" data-id="element-20" data-mp="3nbys2lltwrcw">Bono {index + 1} · </span>
                  {bono.titulo}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-zinc-400" data-id="element-21" data-mp="3ijys4t5rdygb">{bono.beneficio}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}